import PermissionLine from './PermissionLine';
import CapabilityLine from './CapabilityLine';

export default function PermissionSummary({ data = [], capabilities = [], compact = false, scopeChoices, onScopeChange, realmForcesOwn }) {
  // Split capabilities: discovery → connections section, everything else → actions section
  const discoveryItems = capabilities.filter(c => c.kind === 'discovery');
  const actionItems = capabilities.filter(c => c.kind !== 'discovery');

  const hasData = data.length > 0;
  const hasConnections = discoveryItems.length > 0;
  const hasActions = actionItems.length > 0;

  // Schemas carrying a write verb — the own/any toggle applies to these
  const writableSchemas = data.filter(r => r.hasWriteVerb).map(r => r.schema);
  const showScopeAll = !compact && onScopeChange && writableSchemas.length > 0;
  const globalScope = writableSchemas.some(s => scopeChoices?.[s] === 'any') ? 'any' : 'own';
  const handleScopeAll = (val) => writableSchemas.forEach(s => onScopeChange(s, val));

  if (!hasData && !hasConnections && !hasActions) {
    return <div className="perm-empty">No permissions</div>;
  }

  return (
    <div className={`perm-summary${compact ? ' perm-summary--compact' : ''}`}>
      {/* Global scope selector */}
      {showScopeAll && (
        <div className="perm-scope-all">
          <span className="perm-scope-all__label">Which entries can be edited?</span>
          <select
            className="perm-scope-select"
            value={globalScope}
            onChange={e => handleScopeAll(e.target.value)}
            disabled={realmForcesOwn}
            title={realmForcesOwn ? 'Your realm restricts this to new entries only' : undefined}
          >
            <option value="own">Only entries this app creates</option>
            <option value="any">All my entries</option>
          </select>
        </div>
      )}

      {/* Your data — node schemas */}
      {hasData && (
        <div className="perm-section">
          {!compact && <div className="perm-section__label">Your data</div>}
          {data.map((row, i) => (
            <PermissionLine
              key={i}
              schema={row.schema}
              icon={row.icon}
              verbs={row.verbs}
              isOwn={row.isOwn}
              isAllNodes={row.isAllNodes}
              fieldHint={row.fieldHint}
              filterInfo={row.filterInfo}
              filterDetail={row.filterDetail}
            />
          ))}
        </div>
      )}

      {/* Your connections — social discovery */}
      {hasConnections && (
        <div className="perm-section">
          {!compact && <div className="perm-section__label">Your connections</div>}
          {discoveryItems.map((cap, i) => (
            <CapabilityLine key={`d-${i}`} kind={cap.kind} text={cap.text} detailTags={cap.detailTags} />
          ))}
        </div>
      )}

      {/* Actions — plugins + activity */}
      {hasActions && (
        <div className="perm-section">
          {!compact && <div className="perm-section__label">Actions</div>}
          {actionItems.map((cap, i) => (
            <CapabilityLine key={`a-${i}`} kind={cap.kind} text={cap.text} detailTags={cap.detailTags} />
          ))}
        </div>
      )}
    </div>
  );
}
